// Универсальный диалог показа API-токена. Используется для
// перевыпуска токена в ProductPage (и потенциально в других местах).

import { useState } from 'react';
import { Check, Copy, AlertTriangle } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '../../components/ui/dialog.tsx';
import { Button } from '../../components/ui/button.tsx';
import { Label } from '../../components/ui/label.tsx';

interface Props {
  open: boolean;
  token: string | null;
  title: string;
  warning: string;
  onClose: () => void;
}

export function TokenRevealDialog({ open, token, title, warning, onClose }: Props): JSX.Element {
  const [copied, setCopied] = useState(false);

  async function copy(): Promise<void> {
    if (!token) return;
    await navigator.clipboard.writeText(token);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  }

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) {
          setCopied(false);
          onClose();
        }
      }}
    >
      <DialogContent>
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription>Сохрани сейчас — повторно показан не будет.</DialogDescription>

        <div className="mb-3 flex items-start gap-2 rounded border border-danger/40 bg-danger/5 p-3 text-sm text-danger">
          <AlertTriangle className="mt-0.5 h-4 w-4 flex-shrink-0" />
          <span>{warning}</span>
        </div>

        <div className="mb-2 flex items-center justify-between">
          <Label>API-токен</Label>
          <button
            onClick={() => void copy()}
            className="flex items-center gap-1 text-xs text-fg-muted hover:text-accent"
          >
            {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
            {copied ? 'Скопировано' : 'Скопировать'}
          </button>
        </div>
        <code className="block break-all rounded border border-border bg-bg p-3 font-mono text-xs">
          {token ?? ''}
        </code>

        <div className="mt-6 flex justify-end">
          <Button variant="primary" onClick={onClose}>
            Готово
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
